import React, { Component } from "react";
import { Link } from "react-router-dom";

// import Loader
import Loader from "./Loader";

class DashboardLastTransactionsLoader extends Component {
  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
        {/* card for last transactions */}
        <div className="card">
          <div className="card-header">
            <div className="row no-gutters">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                Last Transaction(s)
              </div>
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                <Link to="/transactions" className="card-link">
                  Transactions <i className="fa fa-angle-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="dashboard-transaction-container">
              <div className="small-amount-text">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <Loader width="300" height="30" />
                    <div className="status">
                      <Loader width="150" height="10" />
                    </div>
                  </div>
                  <div className="dashboard-transaction-date col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div className="title">
                      <Loader width="150" height="10" />
                    </div>
                    <div className="date">
                      <Loader width="150" height="10" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="small-amount-text">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <Loader width="300" height="25" />
                    <div className="status">
                      <Loader width="150" height="10" />
                    </div>
                  </div>
                  <div className="dashboard-transaction-date col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div className="title">
                      <Loader width="150" height="10" />
                    </div>
                    <div className="date">
                      <Loader width="150" height="10" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* card for last transactions */}
      </div>
    );
  }
}

export default DashboardLastTransactionsLoader;
